import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { MdVerified } from "react-icons/md";
import { useState } from "react";
import ShortbookSettingsModal from "./ShortbookSettingsModal";
import { FiSettings } from "react-icons/fi";

function PharmacyOrderdashboard() {

  const orderstyles=`
  .custom-scroll::-webkit-scrollbar {
  height: 5px; /* thinner scrollbar */
}

.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #cfcfcf;
  border-radius: 10px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #b0b0b0;
    }
  `

const navigate = useNavigate();

  const [showSettings, setShowSettings] = useState(false);
  return (
    <>
    <style>{orderstyles}</style>
    <div className="p-2 bg-[#f8f8fb] min-h-screen font-sans text-gray-800">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-semibold">Orderbook Dashboard</h1>
        <div className="flex items-center gap-3">
          <button className="text-sm text-pink-600 hover:underline">
            How to Use Orderbook?
          </button>
           <button
          onClick={() => setShowSettings(true)}
          className="gradient-dark-button flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium shadow transition hover:scale-[1.02]"
        >
          <FiSettings className="text-lg" />
          Shortbook Settings (F2)
</button>

        </div>
      </div>
  <ShortbookSettingsModal
        show={showSettings}
        handleClose={() => setShowSettings(false)}
      />
      {/* Top Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-8">
        {[
          { title: "Shortbook Items", value: 491, color: "bg-blue-100 text-blue-600" },
          { title: "Distributors", value: 832, color: "bg-pink-100 text-pink-600" },
          { title: "Items in Cart", value: 87, color: "bg-orange-100 text-orange-600" },
          { title: "Ordered Items", value: 488, color: "bg-green-100 text-green-600" },
          { title: "Order Analysis", value: 960, color: "bg-purple-100 text-purple-600" },
        ].map((item, i) => (
          <div
            key={i}
            className={`rounded-xl p-4 ${item.color} flex flex-col justify-center items-start shadow-sm transition-transform transform hover:scale-[1.03] cursor-pointer`}
          >
            <p className="text-2xl font-bold">{item.value}</p>
            <p className="text-sm">{item.title}</p>
          </div>
        ))}
      </div>

      {/* 📊 Analytics Charts Section */}
     
{/* Local Distributors */}
<div className="mb-6">
  <div className="flex justify-between items-center mb-2">
    <h2 className="text-lg font-semibold">Local Distributors</h2>
    <button className="text-blue-600 text-sm hover:underline">View All &gt;</button>
  </div>

  {/* ✅ Horizontal Scroll */}
  <div className="flex gap-4 overflow-x-auto pb-3 custom-scroll">
    {[
      { name: "Ramesh Medicals", address: "23-567, Mysore Road, Bangalore" },
      { name: "Suresh Medicals", address: "45-875, Shivaji Nagar, Bangalore" },
      { name: "Gambheera Medicals", address: "45-875, Shivaji Nagar, Bangalore" },
      { name: "Ojas Medicals", address: "45-875, Shivaji Nagar, Bangalore" },
      { name: "Ojas Medicals", address: "45-875, Shivaji Nagar, Bangalore" },
    ].map((order, i) => (
      <div
        key={i}
        onClick={() => navigate("/PharmacyOrderDetails")}
        className="flex-shrink-0 w-60 sm:w-72 bg-white rounded-2xl shadow-sm 
                   p-3 flex flex-col justify-between transition-all duration-200 
                   hover:shadow-md hover:scale-[1.02] cursor-pointer"
      >
        {/* Distributor Info */}
        <div>
        <div className="flex items-center gap-1 mb-1">
          <p className="font-medium text-gray-800 text-base m-0">{order.name}</p>
          <MdVerified className="text-green-500 text-lg flex-shrink-0" />
        </div>

          
          {/* ✅ Single-line address */}
          <p className="text-sm text-gray-500 truncate">{order.address}</p>
        </div>

        {/* Order Now Button */}
        <div>
          <button className="mt-2 text-sm font-medium text-green-600 hover:underline">
            Order Now &gt;
          </button>
        </div>
      </div>
    ))}
  </div>
</div>



      {/* Local Distributors */}
      {/* <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">Local Distributors</h2>
          <button className="text-blue-600 text-sm hover:underline">View All &gt;</button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {[
            { name: "Ajay Pharmatech", address: "Rajpet, Guntur" },
            { name: "Arun Pharmatech", address: "Visakhapatnam, Andhra Pradesh" },
            { name: "Arun Pharmatech", address: "Visakhapatnam, Andhra Pradesh" },
            { name: "Arun Pharmatech", address: "Visakhapatnam, Andhra Pradesh" },
            { name: "Arun Pharmatech", address: "Visakhapatnam, Andhra Pradesh" },
          ].map((dist, i) => (
            <div key={i} className="bg-white rounded-xl shadow-sm p-4 flex flex-col justify-between">
              <div>
                <p className="font-medium">{dist.name}</p>
                <p className="text-xs text-gray-500">{dist.address}</p>
              </div>
              <button className="mt-3 text-sm font-medium text-blue-600 hover:underline">
                Order Now &gt;
              </button>
            </div>
          ))}
        </div>
      </div> */}

      {/* Popular Brands */}
      <div className="mb-6">
  <h2 className="text-lg font-semibold mb-3">Popular Brands</h2>

  {/* Horizontal Scroll Wrapper */}
  <div className="flex gap-4 overflow-x-auto pb-3 custom-scroll">
    {[
      { name: "Cipla", color: "from-indigo-100 to-indigo-50",image:"https://www.webshakers.in/wp-content/themes/dp/img/clients/2.png" },
      { name: "SUN Pharma", color: "from-indigo-100 to-indigo-50",image:"https://www.clipartmax.com/png/middle/449-4492184_sun-pharma-logo-sun-pharma-logo-png.png" },
      { name: "Mankind", color: "from-indigo-100 to-indigo-50",image:"https://toppng.com/uploads/preview/mankind-logo-download-mankind-pharma-logo-11562965541a6lqq6vjbv.png" },
      { name: "ALKEM", color: "from-green-100 to-green-50",image:"https://upload.wikimedia.org/wikipedia/commons/f/fb/Alkem_Laboratories_logo.png" },
      { name: "Abbott", color: "from-teal-100 to-teal-50",image:"https://toppng.com/uploads/preview/abbott-logo-vector-free-download-11574202606ngpsdks2te.png" },
      { name: "INTAS", color: "from-purple-100 to-purple-50",image:"https://pnghdpro.com/wp-content/themes/pnghdpro/download/social-media-and-brands/intas-pharmaceuticals-logo-hd.png" },
      { name: "Dr. Reddy’s", color: "from-pink-100 to-pink-50",image:"https://upload.wikimedia.org/wikipedia/en/thumb/b/ba/Dr._Reddy%27s_Laboratories_logo.svg/1280px-Dr._Reddy%27s_Laboratories_logo.svg.png" },
      { name: "Zydus", color: "from-red-100 to-red-50",image:"https://deshgujarat.com/wp-content/uploads/2022/02/zydus_life_logo.png" },
      { name: "Zydus", color: "from-red-100 to-red-50",image:"https://deshgujarat.com/wp-content/uploads/2022/02/zydus_life_logo.png" },
      { name: "Zydus", color: "from-red-100 to-red-50",image:"https://deshgujarat.com/wp-content/uploads/2022/02/zydus_life_logo.png" },
    ].map((brand, i) => (
      <div
        key={i}
         onClick={() => navigate("/PharmacyBrandDetails")}
        className={`flex-shrink-0 w-44 h-24 rounded-2xl bg-gradient-to-br ${brand.color} 
        shadow-sm hover:shadow-md flex flex-col items-center justify-center 
        text-gray-700 font-semibold text-base transition-transform transform hover:scale-[1.03] cursor-pointer`}
      >
        <img src={brand.image} style={{width:"60px",height:'60px'}}/>
      </div>
    ))}
  </div>
</div>
{/* Categories */}
<div className="mb-8">
  <h2 className="text-xl font-bold mb-4 text-gray-800">Shop by Category</h2>

  {/* Horizontal Scroll Wrapper */}
  <div className="flex space-x-4 overflow-x-auto pb-4 custom-scroll md:space-x-6 lg:space-x-8">
    {[
      {
        name: "Ayurvedic Care",
        color: "from-green-200 via-green-100 to-green-50",
        image:
          "https://i.pinimg.com/736x/52/4a/19/524a194ad36c801fb6e73b35d2f1e1d0.jpg",
      },
      {
        name: "Medication",
        color: "from-blue-200 via-blue-100 to-blue-50",
        image:
          "https://i.pinimg.com/736x/2b/66/db/2b66db81ba2345377152f9bdf35ce75f.jpg",
      },
      {
        name: "Mother and Baby Care",
        color: "from-pink-200 via-pink-100 to-pink-50",
        image:
          "https://i.pinimg.com/736x/8a/3d/2f/8a3d2fc5772a0253bd0fec3cd8b7d9d0.jpg",
      },
      {
        name: "Surgicals and Medical Devices",
        color: "from-yellow-200 via-yellow-100 to-yellow-50",
        image:
          "https://i.pinimg.com/736x/0e/76/8b/0e768bcd6ab51d8c31d9d6f83a37be23.jpg",
      },
      {
        name: "Beauty and Skincare",
        color: "from-purple-200 via-purple-100 to-purple-50",
        image:
          "https://i.pinimg.com/736x/78/a8/70/78a87018870caefad6e76678ec99a9bc.jpg",
      },
      {
        name: "Personal Care and Hygiene",
        color: "from-emerald-200 via-emerald-100 to-emerald-50",
        image:
          "https://i.pinimg.com/1200x/dd/b6/bf/ddb6bf8344fe60620f228800b9c4ea26.jpg",
      },
      {
        name: "Nutraceutical",
        color: "from-cyan-200 via-cyan-100 to-cyan-50",
        image:
          "https://i.pinimg.com/736x/37/bf/1d/37bf1d697eaf89fb81374c18b862a7e2.jpg",
      },
      {
        name: "Food and Nutrition",
        color: "from-orange-200 via-orange-100 to-orange-50",
        image:
          "https://i.pinimg.com/736x/68/72/b8/6872b896e47102c87c832d3eadb6ae18.jpg",
      },
    ].map((cat, i) => (
      <a
  key={i}
 onClick={() =>
  navigate(`/PharmacyCategoryDetails/${cat.name.replace(/\s+/g, '-')}`)
}
  className={`flex-shrink-0 w-40 sm:w-48 h-32 rounded-xl md:rounded-2xl bg-gradient-to-br ${cat.color}
  shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300
  flex flex-col items-center justify-center text-center no-underline hover:no-underline`}
  aria-label={`Go to ${cat.name} category`}
>
  <img
    src={cat.image}
    alt=""
    className="w-16 h-16 sm:w-20 sm:h-20 object-contain mb-1"
  />
  <div className="text-gray-900 font-semibold text-xs sm:text-sm px-2 mt-1">
    {cat.name}
  </div>
</a>

    ))}
  </div>
</div>
    </div>
    </>
  );
}

export default PharmacyOrderdashboard;
